import axios from 'axios';
import config from '../config.js';

const INVITATION_LOGIN_URL = 'https://mirukuru-online.com';
const SUBJECT = 'mirukuru-online アカウントのご案内';

const buildInvitationText = ({ name, email, password }) => (
`${name}様 

いつもお世話になっております。

このたび、mirukuru-online のアカウントを作成いたしました。下記の情報にてログインをご確認ください

    ログインURL： ${INVITATION_LOGIN_URL}

    ユーザーID： ${email}

    一時パスワード： ${password}

初回ログイン後、セキュリティ確保のため必ずパスワードの変更をお願いいたします。

今後とも何卒よろしくお願い申し上げます。
`);

const buildInvitationHtml = ({ name, email, password }) => (
`<p>${name}様</p> 
<p>いつもお世話になっております。</p>
<p>このたび、mirukuru-online のアカウントを作成いたしました。下記の情報にてログインをご確認ください。</p>
<ul>
  <li>ログインURL： <a href="${INVITATION_LOGIN_URL}">${INVITATION_LOGIN_URL}</a></li>
  <li>ユーザーID： ${email}</li>
  <li>一時パスワード： ${password}</li>
</ul>
<p>初回ログイン後、セキュリティ確保のため必ずパスワードの変更をお願いいたします。</p>
<p>今後とも何卒よろしくお願い申し上げます。</p>
`);

/**
 * Send invitation email for a newly created mirukuru-online account.
 * @param {Object} params
 * @param {string} params.name - Recipient display name.
 * @param {string} params.email - Recipient email address.
 * @param {string} params.password - Temporary password to share.
 * @param {string} [params.token] - Optional Cognito ID token for authorization.
 */
export const sendInvitationEmail = async ({ name, email, password, token }) => {
  if (!name || !email || !password) {
    throw new Error('name, email, and password are required to send invitation email');
  }

  const text = buildInvitationText({ name, email, password });
  const html = buildInvitationHtml({ name, email, password });

  const formData = new FormData();
  formData.append('data', JSON.stringify({
    to: email,
    subject: SUBJECT,
    text,
    html,
  }));

  const requestConfig = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

  await axios.post(config.sendInvitationApiUrl, formData, requestConfig);
};
